/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  /**
   *
   */
  onFinishRender.$inject = ['$timeout'];
  export function onFinishRender($timeout :ng.ITimeoutService): ng.IDirective {
    return {
      restrict: 'A',
      link: function (scope : ng.IRepeatScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        if (scope.$last === true) {
          $timeout(function () {
            scope.$emit('ngRepeatFinished');
          });
        }
      }
    }
  }
}